var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:_vm.pc ? 'inner' : 'moinner'},[_c('p',{class:_vm.pc ? 'title' : 'motitle'},[_vm._v(_vm._s(_vm.$t('notFound.title')))]),_c('p',{class:_vm.pc ? 'text' : 'motext'},[_vm._v(_vm._s(_vm.$t('notFound.text')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }